import {Client, ForeverMemoryStorage, middlewares} from '@synako/halitrek';
import i18next from 'i18next';

export function createClient(initialLanguage: string) {
  const client = new Client(
    new URL(
      import.meta.env.VITE_API_ROOT_URL,
      window.location.toString(),
    ).toString(),
  );
  // pour éviter une perte de cache trop rapide, on allonge sa durée de vie à 20 minutes
  client.stateStorage = new ForeverMemoryStorage();

  // Dynamic Accept-Language middleware qui lit la langue actuelle de i18next
  client.fetcher.use(async (request, next) => {
    const currentLanguage = i18next.language || initialLanguage;

    // Set the Accept-Language header dynamically
    request.headers.set('Accept-Language', currentLanguage);

    return next(request);
  });

  client.fetcher.use(middlewares.credentials('include'));
  client.fetcher.use(
    middlewares.checkContentType([
      'application/json',
      'application/problem+json',
    ]),
  );
  // TODO : à réfléchir : un middleware front pour catcher tous les erreurs ? ou alors à gérer ailleurs ?
  //Redirect on 503
  client.fetcher.use(async (request, next) => {
    const res = await next(request);
    if (res.status === 503) {
      window.location.href = '/';
    }
    return res;
  });
  return client;
}
